// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

// صفحات اصلی
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import RoomPage from "./pages/RoomPage";
import WatchPage from "./pages/WatchPage";
import VideoCallPage from "./pages/VideoCallPage";
import ChessGamePage from "./pages/ChessGamePage";
import GameSelectPage from "./pages/GameSelectPage";
import SelectModePage from "./pages/SelectModePage";
import NotFound from "./pages/NotFound";

// 🃏 صفحات مربوط به بازی پاسور
import PasoorGameSelector from "./pages/PasoorGameSelector";
import PasoorRoomPage from "./pages/PasoorRoomPage";
import PasoorGamePage from "./pages/PasoorGamePage"; // مسیر اجرای بازی

export default function App() {
  return (
    <Routes>
      {/* ورود و صفحات اصلی */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/room/:roomCode" element={<RoomPage />} />
      <Route path="/watch/:roomCode" element={<WatchPage />} />
      <Route path="/video-call/:roomCode" element={<VideoCallPage />} />
      <Route path="/select/:roomCode" element={<SelectModePage />} />
      <Route path="/game/:roomCode" element={<GameSelectPage />} />
      <Route path="/chess/:roomCode" element={<ChessGamePage />} />

      {/* 🃏 مسیرهای بازی پاسور */}
      <Route path="/pasoor" element={<PasoorGameSelector />} />
      <Route path="/pasoor/:roomCode" element={<PasoorRoomPage />} />
      <Route path="/pasoor/game/:gameType/:playerCount" element={<PasoorGamePage />} />

      {/* صفحه 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}